export default __webpack_public_path__ + "static/media/success_icon.98175b12.svg";